// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Image
import eparoxosIcon from "assets/images/custom/eparoxos-navbar.png";
import AuthLayout from "views/layouts/AuthLayout";
import { useState } from "react";

import ApiService from "services/ApiService";
import Swal from "sweetalert2";

function InvoiceFailure() {
  const [vatNumber, setVatNumber] = useState("");
  const [searchDisabled, setSearchDisabled] = useState(true);

  const handleVatChange = (e) => {
    setVatNumber(e.target.value);
    if (e.target.value.length === 9) setSearchDisabled(false);
    else setSearchDisabled(true);
  };

  const handleSearch = async () => {
    const response = await ApiService.getData(
      `/api/v1/invoices/count-erp-failures?vatNumber=${vatNumber}`
    );
    if (!response) return;

    Swal.fire({
      icon: "warning",
      title: `Παραστατικα: ${response.data.invoices}`,
      text: "Σύνολο διαβιβασμένων παραστατικών με οποιαδήποτε απώλεια διαβίβασης για τον τρέχον μήνα.",
      showCancelButton: false,
      confirmButtonText: "OK",
    });
  };

  return (
    <AuthLayout
      title="Απώλειες Διασύνδεσης"
      description="Ελέγξτε τις απώλειες διασύνδεσης της επιχείρησής σας για τον τρέχον μήνα. Πληκτρολογήστε το ΑΦΜ που σας και πατήστε αναζήτηση."
      illustration={{
        image: eparoxosIcon,
      }}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftInput type="number" placeholder="ΑΦΜ" size="large" onChange={handleVatChange} />
        </SoftBox>

        <SoftBox mt={4} mb={1}>
          <SoftButton
            variant="gradient"
            color="warning"
            size="large"
            onClick={handleSearch}
            disabled={searchDisabled}
            fullWidth
          >
            ΑΝΑΖΗΤΗΣΗ
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </AuthLayout>
  );
}

export default InvoiceFailure;
